import React from 'react';
import styled from '@emotion/styled';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import resolveLocalisation from '../../utils/resolveLocalisation';

export const TableWrapper = styled.table`
  td {
    vertical-align: top;

    > * {
      padding: 0;
    }
  }
`;

export const Table2ColumnRow = ({ node, options }) => {
  const fields = node.data.target.fields;
  const cells = [
    resolveLocalisation(fields.cell1),
    resolveLocalisation(fields.cell2),
  ];
  return (
    <tr>
      {cells.map(cell => (
        <td>{documentToReactComponents(cell, options)}</td>
      ))}
    </tr>
  );
};

type TableHeadingProps = {
  headings: Array<Record<string, string>>;
};

const TableHeading = ({ headings }: TableHeadingProps) => {
  return (
    <thead>
      <tr>
        {headings.map(heading => (
          <th>{heading}</th>
        ))}
      </tr>
    </thead>
  );
};

const defaultHeading = (
  Component: React.ComponentType<TableHeadingProps>,
  { fields },
): JSX.Element => {
  const headings = resolveLocalisation(fields.headings);
  return <Component headings={headings} />;
};

interface TableProps {
  options: Record<string, any>;
  node: Record<string, any>;
  renderHeading?: (
    Component: React.ComponentType<TableHeadingProps>,
    ctx: {
      fields: Record<string, any>;
    },
  ) => JSX.Element;
}

export const Table = ({
  options,
  node,
  renderHeading = defaultHeading,
}: TableProps) => {
  const fields = resolveLocalisation(node.data.target.fields);
  const rows = resolveLocalisation(fields.rows);
  return (
    <TableWrapper>
      {renderHeading(TableHeading, { fields })}
      <tbody>
        {rows.content.map(row => documentToReactComponents(row, options))}
      </tbody>
    </TableWrapper>
  );
};

export const TableRow = ({ node, options }) => {
  const fields = resolveLocalisation(node.data.target.fields);
  const cells = resolveLocalisation(fields.cells);
  return (
    <tr>
      {cells.content.map(cell => documentToReactComponents(cell, options))}
    </tr>
  );
};

export const TableCell = ({ node, options }) => {
  const fields = resolveLocalisation(node.data.target.fields);
  const content = resolveLocalisation(fields.content);
  return <td>{documentToReactComponents(content, options)}</td>;
};

export default Table;
